import { Controller } from '@hotwired/stimulus';

// Photos du rapport (tks/shared/_report_photos) : aperçu du
// fichier choisi dans son cadre ; « Caméra » (outlet webcam) quand le
// navigateur donne accès à la caméra, sauf sur Android et iOS (téléphone,
// tablette), dont le champ propose déjà l'appareil photo.
export default class extends Controller {
    static targets = ['webcamButton'];
    static outlets = ['webcam'];

    connect() {
        const mobileOs = /Android|iPhone|iPad|iPod/.test(navigator.userAgent)
            || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
        const webcam = Boolean(navigator.mediaDevices?.getUserMedia) && !mobileOs;
        this.webcamButtonTargets.forEach((button) => { button.hidden = !webcam; });
    }

    preview({ target }) {
        const frame = target.type === 'file' && target.closest('[data-photo-frame]');
        if (!frame) return;
        const file = target.files && target.files[0];
        const image = frame.querySelector('[data-photo-preview]');
        if (image.src) URL.revokeObjectURL(image.src);
        image.hidden = !file;
        frame.querySelector('[data-photo-empty]').hidden = Boolean(file);
        frame.querySelector('[data-photo-choose]').textContent = file ? 'Changer' : 'Ajouter une photo';
        if (file) image.src = URL.createObjectURL(file);
        else image.removeAttribute('src');
    }

    capture({ currentTarget }) {
        this.webcamOutlet.open(currentTarget.closest('[data-photo-frame]').querySelector('input[type="file"]'));
    }
}
